import React, { Fragment, useCallback } from 'react';
import { capitalize } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { openDashboardDialog } from '@actions/dashboard-actions';
import { getEntityTypeLabel } from '@constants/config';
import * as dialog from '@constants/dialogs';
import { isEntity } from '@constants/endpoints';
import { Skeleton } from '@mui';
import { getBatch } from '@utils/batch-utils';
import UnstyledHeading from '@components/shared/unstyled-heading';

import './top-bar.scss';

const TopBarTitle = () => {
  const dispatch = useDispatch();
  const { dataType, id } = useParams();
  const { data } = useSelector(state => state.dataDetail);
  const { cycle } = useSelector(state => state.workflow);
  const dataTypeDisplayName = getEntityTypeLabel(dataType);
  const openDialog = useCallback(
    () => dispatch(openDashboardDialog(dialog.NAME_DESCRIPTION, { dataType, id, portal: 'admin' })),
    [dataType, dispatch, id]
  );
  const hasEditIcon = data && (dataType === 'task_type' || dataType === 'workflow');
  const label = dataType === 'cycle' ? cycle?.name : data?.name;

  if (dataType === 'batch-upload-edit') {
    const batch = getBatch(id);
    return (
      <div styleName="title">
        <div styleName="header">
          <UnstyledHeading rank={2} styleName="header-text">
            Batch upload: {capitalize(batch.entity)}
          </UnstyledHeading>
        </div>
        <div styleName="subtitle">
          {batch.file.path}
        </div>
      </div>
    );
  }

  return (
    <div styleName="title">
      {id && id !== 'new' && (
        <Fragment>
          <div styleName="header">
            {label && <UnstyledHeading rank={2} styleName="header-text">{label}</UnstyledHeading>}
            {hasEditIcon && (
              <div styleName="header-icon">
                <EditOutlinedIcon
                  htmlColor="#616161"
                  onClick={openDialog}
                  onKeyDown={event => (event.key === 'Enter' || event.key === ' ') && (event.preventDefault() || openDialog())}
                  role="button"
                  tabIndex={0}
                  aria-label={`Edit ${dataTypeDisplayName} name`}
                  style={{ fontSize: '1.375rem', padding: '0 0 0 1rem' }}
                />
              </div>
            )}
            {!label && <Skeleton width="100%" />}
          </div>
          {isEntity(dataType) && (
            <div styleName="subtitle">
              ID {data && data.id}
            </div>
          )}
          {dataType === 'cycle' && cycle && (
            <div styleName="subtitle">
              {cycle.workflow_name}
            </div>
          )}
        </Fragment>
      )}
      {(!id || id === 'new') && (
        <UnstyledHeading rank={2} styleName="header">
          Create new {dataTypeDisplayName}
        </UnstyledHeading>
      )}
    </div>
  );
};

export default TopBarTitle;
